/** Способ создания черновика: декларирование доходов от продажи имущества */
export const DRAFT_MODE = 5;
export const STEP_INCOME = 'income';
export const STEP_INCOME_FORM = `${STEP_INCOME}Form`;

export const TAX_RATE = 13;
export const SOURCE_TYPE = 2;
